<template>
    <div class="tree">
        <ul class="tree-main-node opened">
            <draggable :list="ItreeData" :element="'li'" :options="options" class="tree-node"
                       @start="handleStart" @end="handleEnd" :move="handleMove" :data-id="rootId">
                <TreeNode v-for="node in ItreeData" :key="node.id" :treeData="node" :options="options" :level="0"
                          :icons="icons"
                          :sortHandler="handleNodeSort" :moveHandler="handleNodeMove" :clickHandler="onNodeClick"
                          :rightClickHandler="onNodeRightClick"></TreeNode>
            </draggable>
        </ul>
    </div>
</template>


<script>
    import TreeNode from './TreeNode'
    import Sortable from 'sortablejs';
    import draggable from 'vuedraggable'
    import state from '@/services/PlanTreeState';
    import Utils from '@/services/utils.js';

    export default {
        components: {
            TreeNode,
            draggable
        },
        computed: {
            rootId: function () {
                if (this.root != null) {
                    return this.root.id;
                }
                return null;
            }
        },
        name: 'tree',
        props: {
            treeData: [Array],
            root: {
                type: [Object],
                default: function () {
                    return {
                        id: 0
                    }
                }
            },
            options: {
                type: [Object],
                default: function () {
                    return {
                        sortable: false,
                        keepActivate: true,
                        constrain: true
                    }
                }
            },
            optionsDraggable: {
                handle: ".handler",
                groupe: 'test',
            },
            selected: {
                type: Object,
                default: null
            },
            icons: {
                type: [Object],
                default: function () {
                    return {}
                }
            }
        },
        data () {
            return {
                ItreeData: this.treeData
            }
        },
        methods: {
            handleStart: function (evt) {
                evt.target.classList.add('sorting-activate');
                document.getElementsByClassName('tree-main-node')[0].classList.add('sorting');
            },
            handleEnd: function (evt) {
                document.getElementsByClassName('tree-main-node')[0].classList.remove('sorting');
                evt.target.classList.remove('sorting-activate');
                this.$emit('endDrag', evt);
            },
            handleMove: function (evt) {
                this.$emit('move', evt);
            },
            handleNodeMove: function (evt) {
                this.$emit('move', evt);
            },
            handleNodeSort: function (evt) {
                this.$emit('endDrag', evt);
            },
            onNodeClick: function (node) {
                this.unactivateNodes(node);
                this.$emit('treeNodeClick', node);
            },
            onNodeRightClick: function (evt, node) {
                this.$emit('treeNodeRightClick', evt, node);
            },
            unactivateNodes: function (nodeToKeep) {

                for (var node in this.ItreeData) {
                    this.unactivateNode(this.ItreeData[node], nodeToKeep);
                }

            },
            unactivateNode: function (node, nodeToKeep) {

                if (nodeToKeep == null) {
                    node.active = false;
                    return;
                }

                if (node.id != nodeToKeep.id) {
                    node.active = false;
                }

                if (node.children != null) {
                    for (var node2 in node.children) {
                        this.unactivateNode(node.children[node2], nodeToKeep);
                    }
                }
            },
            activateNode: function (node) {
                if (this.options.keepActivate)
                    node.active = true;
            },
            forceHeight: function (node) {
                if (node.children && node.children.length > 0) {
                    for (var child in node.children) {
                        if (state.opened[node.children[child].id] == null) {
                            state.opened[node.children[child].id] = false;
                        }
                        this.$set(node.children[child],'opened',state.opened[node.children[child].id]);
                        this.forceHeight(node.children[child]);

                    }
                }
            },
            externalSelect: function (tree,nodeToSelect) {

                this.ItreeData = tree;


            }
        },
        mounted: function () {
            var vThis = this;

            for (var child in this.ItreeData) {
                this.ItreeData[child].opened = true;
                this.forceHeight(this.ItreeData[child]);
            }

        },
        watch: {
            treeData: function (newValue) {
                this.ItreeData = newValue;
                for (var child in this.ItreeData) {
                    if (state.opened[this.ItreeData[child].id] == null) {
                        state.opened[this.ItreeData[child].id] = false;
                    }

                    this.ItreeData[child].opened = state.opened[this.ItreeData[child].id];
                    this.forceHeight(this.ItreeData[child]);

                }
            },
            selected: function(newValue){


            }
        }
    }
</script>

<style scoped>

</style>

